import { ApiUrl2,UserToken } from '../../../helper/HelperAuth'
import { GlobalLoading } from '../../../store/constants'
import doFetch from '../../../infra/helper/fetchHelper'
import { fromJS } from 'immutable';

export default (file,clientId,divisionId,senderid,sender,typefile) => async (dispatch, getState) => {
    dispatch({ type: GlobalLoading, showLoading: true, latestProcessStatus: false });

    const Authorization = UserToken;
    const url = ApiUrl2 + 'media-id-upload-file';
    const data = new FormData();
    data.append('file', file );
    //tambahan
    data.append('client-id',clientId)
    data.append('division-id',divisionId)
    data.append('sender-id',senderid)
    data.append('sender-name',sender)
    const argument = {
        method: 'POST',
        headers : {
            'Authorization': Authorization,
        },
        body : data
    };
    const response = await doFetch(url,argument);
    
    dispatch({ type: GlobalLoading, showLoading: false, latestProcessStatus : response.ok });

        if(response.ok){
            try {
                var res = fromJS(await response.json());
                res = res.get('uploads-file').get('data');
                return fromJS({
                    'success': true,
                    'media-id': res.get('media-id')
                });
            } catch (error) {
                console.log(error)
            }
            
            return fromJS({
                'success': true,
                'media-id': ''
            });
            
        }
    
    return fromJS({
        'success': false
    })
};